import { render, staticRenderFns } from "./IviewModal.vue?vue&type=template&id=3c872074&scoped=true&"
import script from "./IviewModal.vue?vue&type=script&lang=js&"
export * from "./IviewModal.vue?vue&type=script&lang=js&"
import style0 from "./IviewModal.vue?vue&type=style&index=0&id=3c872074&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c872074",
  null
  
)

export default component.exports